import { render } from "./TabsPage.vue?vue&type=template&id=2e8463c0&scoped=true&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=2e8463c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8463c0"]])

export default __exports__